module.exports = __webpack_public_path__ + "static/media/Figtree-Medium.04934731.ttf";